<template>
  <v-menu
      dark
      bottom
      right
      nudge-bottom="28"
      :close-on-content-click=true
      :close-on-click=false
      v-model="orgOpen"
  >
    <template v-slot:activator="{ on: { click }}">
      <div class="org-dropdown-title-cont" @click.capture.stop="(click) (orgOpen = !orgOpen)">
        <div
            class="org-dropdown-title"
            :style="{ color: orgOpen ? $vuetify.theme.themes.dark.primary : '#fff' }"
        >
          {{ selectedOrg }}
        </div>
        <img
            src="../assets/graphic/button-dropdown-arrow.svg"
            alt="dropdown-arrow"
            width="11"
            height="7"
            :style="{ transform: orgOpen ? 'rotate(180deg)' : 'none' }"
        />
      </div>
    </template>
    <v-list :width=" $vuetify.breakpoint.xs ? '200px': '271px'">
      <v-list-item v-for="(org, key) in orgOptions" :key="key" @click="onOrgChange(org)">
        <v-list-item-title class="org-dropdown-item">{{ org }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
  export default {
    component: 'OrganizationDropdown',
    props: {
      onClickOrg: {
        type: Function
      },
      organization: {
        type: String,
        default: 'Organization'
      },
      hideAll: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
        orgOpen: false,
        selectedOrg: this.organization,
        orgOptions: [
            'Notes for Notes',
            'Little Kids Rock'
        ]
      }
    },
    methods: {
      onOrgChange(org) {
        this.selectedOrg = org;
        this.onClickOrg(org);
      },
      toggleOrgOpen () {
        this.orgOpen = !this.orgOpen;
      }
    },
    created () {
      if (!this.hideAll) {
        this.orgOptions.unshift('All');
      }
    }
  }
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
  .org-dropdown-title,
  .org-dropdown-item {
    font-family: Lato-Bold, sans-serif;
    font-size: 15px;
  }

  .org-dropdown-title {
    text-transform: uppercase;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .org-dropdown-title,
    .org-dropdown-item {
      font-size: 12px;
    }
  }
</style>